<template>
  <div class="menuFrame">
    <div class="container py-3">
      <div
        class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center"
      >
        <a href="https://www.chanchao.com.tw/th/">
          <div class="d-flex align-items-center">
            <img
              src="../../assets/images/ChanChaoLogo.png"
              class="navLogo mt-2"
            />
            <div class="mx-2 logoText text-dark font-weight-nomal">
              <div>สมาชิกจ่านจาว</div>
            </div>
          </div>
        </a>

        <div>
          <select
            class="form-control language-select"
            v-model="selectedLang"
            @change="switchLanguage"
          >
            <option
              v-for="lang in languages"
              :key="lang.value"
              :value="lang.value"
            >
              {{ lang.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="rightline col-md-7 my-4 px-4">
          <div class="d-flex align-items-center">
            <img
              src="../../assets/images/PwIcon.png"
              class="mr-2 mb-2"
              style="width: 30px; height: 30px"
              alt=""
            />
            <h4>ลืมรหัสผ่าน</h4>
          </div>
          <p class="my-4">
            Forgot your password? Enter your email address and we'll help you
            reset your password.
          </p>
          <form>
            <div class="form-group h6">
              <label for="forgetpwEmail">ที่อยู่อีเมล</label>
              <input
                type="email"
                class="form-control"
                id="forgetpwEmail"
                maxlength="50"
                aria-describedby="emailHelp"
                v-model="email"
                name="email"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                ref="forgetpwEmail"
              />
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('email')"
                >{{ errors.first("email") }}
              </span>
            </div>

            <div class="form-group h6">
              <label for="forgetpwcode">รหัสยืนยัน</label>
              <div class="d-flex justify-content-center align-items-center">
                <input
                  type="text"
                  class="form-control mr-1"
                  id="forgetpwcode"
                  maxlength="5"
                  v-model="validcode"
                  name="text"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  ref="forgetpwcode"
                />
                <img
                  :src="getsrc"
                  class="img-fluid rounded"
                  @click.prevent="resetValidcode"
                  style="width: 120px; height: 35px"
                />
                <a href="#" @click.prevent="resetValidcode">
                  <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                </a>
              </div>
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('text')"
                >ช่องรหัสยืนยันเว้นว่างไม่ได้</span
              >
            </div>

            <button
              type="submit"
              class="btn btn-block btn-primary mt-4"
              @click.prevent="getResetlink"
            >
              แก้ไขรหัสผ่าน
            </button>
          </form>

          <div v-if="!Registered">
            <hr />

            <div class="linkFrame">
              <a href="https://www.chanchao.com.tw/accounts/th/login"
                >ออกจากระบบ</a
              >

              <span>
                / คุณยังไม่เข้าร่วมสมาชิก?
                <a href="https://www.chanchao.com.tw/accounts/th/signup"
                  >ลงทะเบียน</a
                >
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <div class="d-flex align-items-center mb-4">
            <i
              class="fas fa-2x fa-question-circle mr-3 mb-2"
              style="color: #ffa042"
            ></i>
            <h4>คำถามที่พบบ่อย</h4>
          </div>
          <p style="font-weight: bold">
            Q: ทำไมไม่ได้รับ E-mail หรือรหัสยืนยัน
          </p>
          <hr />

          <ol class="ml-0 pl-3">
            <li style="font-size: 15px" class="font-weight-bold mb-3">
              ถูกจำแนกเป็น "อีเมลขยะ" หรือไม่ ?
            </li>
            <p style="font-size: 14px">
              Please go to your junk folder to see if the email message or
              verification code is there. If you find it in the junk folder,
              remember to set it as a non-junk mail so that similar emails will
              be sent to your inbox.
            </p>

            <li style="font-size: 15px" class="font-weight-bold mb-3">
              หลังจากกรอกอีเมลแล้ว ไม่เห็นรหัสยืนยันเข้ามา ?
            </li>
            <p style="font-size: 14px">
              You can wait a few minutes for the system to send you the
              verification code. If you still fail to receive it, please check
              to see if you have entered a wrong email address.
            </p>

            <div class="d-flex mt-3">
              <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
                >คำถามที่พบบ่อยเพิ่มเติม<i
                  class="fas fa-external-link-alt ml-2"
                ></i
              ></a>
            </div>
          </ol>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer_en.vue";

export default {
  metaInfo: {
    title: "ลืมรหัสผ่าน - Chan Chao Exhibition Hall",
  },
  components: {
    Footer,
  },

  data() {
    return {
      getsrc: "",
      email: "",
      validcode: "",
      alertTitle: "",
      alertText: "",
      lastUrl: "",
      CSRF_Token: "",
      Registered: false,

      selectedLang: "th",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
      ],
    };
  },

  watch: {
    email: function () {
      const vm = this;
      vm.$refs.forgetpwEmail.style.borderColor = "#ced4da";
    },

    validcode: function () {
      const vm = this;
      vm.$refs.forgetpwcode.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/forgetPw`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/forgetPw`;
      }
    },
    getResetlink() {
      const vm = this;
      if (vm.lastUrl.length === 0) {
        vm.lastUrl = "https://www.chanchao.com.tw/th";
      }

      const linkinfo = {
        Email: vm.email,
        Validcode: vm.validcode,
        CSRF: vm.CSRF_Token,
      };

      const url = "https://www.chanchao.com.tw/apiLogin2/forgetPw/th";

      vm.$validator.validate().then((valid) => {
        if (valid) {
          vm.$http.post(url, linkinfo).then(function (response) {
            // // console.log(response)
            if (response.data == "200") {
              vm.alertTitle = "สำเร็จ";
              vm.alertText = "อีเมลรีเซตรหัสผ่านได้ส่งออกแล้ว";
              vm.alertSuccess();
            } else if (response.data == "252") {
              vm.alertText = "บัญชีของคุณถูกระงับการใช้";
              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "253") {
              vm.alertText = "คุณยังไม่เข้าร่วมสมาชิก";
              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "254") {
              vm.alertText =
                "คุณใส่ที่อยู่อีเมลผิดพลาด หรือยังไม่เข้าร่วมสมาชิกจ่านจาว";

              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "255") {
              vm.alertText = "โปรดใส่ที่อยู่อีเมลของคุณ";
              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "256") {
              vm.alertText = "รหัสยืนยันผิดพลาด โปรดใส่ใหม่";
              vm.alertError();
              vm.$refs.forgetpwcode.style.borderColor = "red";
            } else {
              vm.alertText = "ระบบไม่ว่าง โปรดเข้าสู่ระบบภายหลัง";
              vm.alertError();
            }
          });
        } else {
          vm.alertText = "ช่องใส่ข้อมูลไม่ครบถ้วน โปรดตรวจสอบอีกครั้ง";
          vm.alertError();
        }
      });
    },

    alertError() {
      const vm = this;

      vm.$swal({
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccess() {
      const vm = this;

      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      }).then(function () {
        document.location.href =
          "https://www.chanchao.com.tw/accounts/th/login";
      });
    },

    resetValidcode() {
      const vm = this;
      vm.$http
        .get("https://www.chanchao.com.tw/apiLogin2/Validcode")
        .then((response) => {
          vm.getsrc = response.data;
        });
    },
  },

  created() {
    const vm = this;

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/Validcode")
      .then((response) => {
        this.getsrc = response.data;
      });

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    vm.$i18n.locale = "th";

    //是否登入狀態

    //取cookie
    // vm.access_token = vm.$cookies.get('as')

    const url = "https://www.chanchao.com.tw/apiLogin2/isAuthenticated";
    const info = null;

    vm.$http.post(url, info).then(function (response) {
      // console.log(response.data)
      if (response.data == 200) {
        vm.Registered = true;
      } else {
        vm.Registered = false;
      }
    });
  },
};
</script>

<style lang="scss">
//Swal setting
.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 12px;
}

#main-footer {
  bottom: 0;
}

.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
}

.navLogo {
  height: 55px;
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.rightline {
  border-right: 1px solid #ccc;
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

input::-webkit-input-placeholder {
  /* placeholder*/
  color: #aab2bd;
  font-size: 14px;
}

.linkFrame {
  font-size: 15px;
}

.navText {
  display: flex;
}

.logoText {
  font-size: 20px;
}

@media (max-width: 768px) {
  .navLogo {
    height: 50px;
  }
  .rightline {
    border-right: 0px;
  }

  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
    padding-top: 30px;
  }

  .navEnText {
    display: none;
  }

  .navText {
    display: block;
  }

  .logoText {
    font-size: 16px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
